import _ from 'lodash';
import join from 'url-join';
// const uri = require('urijs');
import uri from 'urijs';
// const HttpStatus = require('http-status-codes');
import HttpStatus from 'http-status-codes';

import _debug from 'debug';

const debug = _debug('sails');
debug.log = console.log.bind(console);


// TODO: Consolidate this socket and the one mutated by angular-sails
let socket;
const $q = window.angular.injector(['ng']).get('$q');

/**
 * @constant
 * @type {Function[]}
 */
const __subscriptions__ = [];

class Service {

  constructor(rootRoute, store) {
    // ? Calling this injector in the global scope of this file caused digest issues
    socket = window.angular.injector(['ngSails']).get('$sails');

    this.route = join('/', rootRoute);

    /**
     * Patch for digest issues caused by use of class getter
     *
     * @type {any[]}
     */
    let getterCache;
    this.store = store || {
      byId: {},
      get array() {
        let storeValues = _.values(this.byId);
        // By default, sort by name
        if (storeValues.length && storeValues[0].name) {
          storeValues = _.sortBy(storeValues, 'name');
        }
        if (!_.isEqual(getterCache, storeValues)) {
          getterCache = storeValues;
        }
        return getterCache;
      },
      // byType?
      // prevent outside mutation?
    };
    // TODO: These will need to be added once $sails is consolidated into this service
    // this.on = socket.on.bind(socket);
    // this.off = socket.off.bind(socket);
  }

  model() {
    return this.store;
  }


  /**
   * @param {string|string[]} [path=''] path
   * @param {object} [query={}] key-value pairs to pass as URL params
   * @returns {Promise}
   * TODO: Entities retrieved here do not share reference to store
   */
  async get(path = '', query = {}) {
    if (Array.isArray(path)) {
      path = join(path);
    }
    const req = uri(join(this.route, path)).query(query);
    return makeRequest('get', req.toString()).then((res) => {
      const data = _.castArray(res.data);
      if (_.has(data[0], 'id')) {
        _.merge(this.store.byId, _.keyBy(data, 'id'));
      }
      return res;
    });
  }

  /**
   * @param {string|string[]} [path=''] path
   * @param {object} [thing={}] payload
   * @returns {Promise}
   */
  post(path = '', thing = {}) {
    if (Array.isArray(path)) {
      path = join(path);
    } else if (_.isObject(path)) {
      // Support posting to (root) route and just passing payload
      thing = path;
      path = '';
    }
    return makeRequest('post', join(this.route, path), thing).then((res) => {
      const data = _.castArray(res.data);
      if (_.has(data[0], 'id')) {
        _.merge(this.store.byId, _.keyBy(data, 'id'));
      }
      return res;
    });
  }

  /**
   * @param {string} id id
   * @returns {Promise}
   */
  delete(id) {
    if (!id) {
      return $q.reject(new TypeError('invalid arguments'));
    }
    return makeRequest('delete', join(this.route, id)).then((res) => {
      delete this.store.byId[id];
      return res;
    });
  }

  /**
   * @param {string} path path
   * @param {object} thing payload
   * @returns {Promise}
   */
  put(path, thing) {
    // TODO: Refactor put to gracefully handle several paths. E.g.: /thing/id AND /thing/verb/id
    //       instead of consuming paths as a single path.
    return makeRequest('put', join(this.route, path), thing).then((res) => {
      const data = _.castArray(res.data);
      if (_.has(data[0], 'id')) {
        data.forEach(datum => Object.assign(this.store.byId[datum.id], datum));
      }
      return res;
    });
  }


  /**
   * @typedef {object} Subscription
   * @property {Function} [created]
   * @property {Function} [updated]
   * @property {Function} [destroyed] (Synonym for deleted)
   * @property {Function} [deleted] (Synonym for destroyed)
   */

  /**
   * @param {Subscription} subscriptions Subscriptions to register
   * TODO: Support subscription array form
   * @param {string} [target] E.g.: rcu is the target of the listener `rcu:created`
   * @returns {undefined}
   * @throws ArgumentError
   */
  static subscribe(subscriptions, target) {
    if (_.isEmpty(subscriptions)) {
      throw new Error('Invalid args');
    }

    if (!target) {
      console.warn('Registering subscription(s) without explicitly setting target will use route as fallback');
      target = _.trim(this.route, '/');
    }
    debug(`Subscribing event listeners for ${target}:`);
    debug(subscriptions);
    __subscriptions__.push(..._.map(subscriptions, (cb, name) => socket.on(_.join([target, name], ':'), cb)));
  }

  /**
   * TODO: Allow for selective unsubscribing rather than all
   *
   * @returns {undefined}
   */
  static unsubscribe() {
    debug(`Unsubscribing event listeners for ${this.route}:`);
    __subscriptions__.forEach(sub => debug(sub));

    __subscriptions__.forEach(disable => disable());
    __subscriptions__.length = 0;
  }

  // =============== Helpers =============== //


}

function makeRequest(method, ...args) {
  const requestName = `${_.upperCase(method)}ing ${args[0]}`;

  debug(requestName);
  ['post', 'put'].includes(requestName) && debug(...args.slice(1));

  return $q((resolve, reject) => {
    // TODO: This legacy method is only needed as long as $sails is mutating the raw socket object
    const legacyMethod = `legacy_${method}`;
    socket[legacyMethod](...args, (body, jwr) => {
      // Consolidate body into the jwr
      if (!jwr) {
        jwr = {
          body,
          headers: body.headers || {},
          statusCode: body.statusCode || body.status || 0,
          error: (function () {
            if (this?.statusCode < HttpStatus.OK || this?.statusCode >= HttpStatus.BAD_REQUEST) {
              return this.body || this?.statusCode;
            }
          })(),
        };
      }

      // Angular $http compatibility
      jwr.data = jwr.body; // TODO: Default for null safety?
      jwr.status = jwr.statusCode;

      const badResponse = jwr.statusCode < HttpStatus.OK || jwr.statusCode >= HttpStatus.BAD_REQUEST;
      debug(`RESPONSE ${requestName} %O`, badResponse ? jwr.error : jwr);
      return badResponse ? reject(jwr) : resolve(jwr);
    });
  });
}

export default Service;
